<template>
  <div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/">
        <icon name="dashboard" class="mr-2" :class="isUrl('') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('message.menu.dashboard') }}</div>
      </Link>
    </div>
    <div class="mb-4">
      <menu-accordion :active="activeMenu === 'tickets'" @toggle="toggleMenu('tickets')">
        <template #title>
          <div :class="isUrl('tickets') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('message.menu.tickets') }}</div>
        </template>
        <template #content>
          <Link v-if="hasPermission('view issues')" class="group flex items-center py-3 truncate" href="/tickets/issues">
            <icon name="tickets" class="mr-2" :class="isUrl('tickets/issues') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
            <div :class="isUrl('tickets/issues') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('message.menu.issues') }}</div>
          </Link>
          <Link class="group flex items-center py-3 truncate" href="/tickets/tickets">
            <icon name="tickets" class="mr-2" :class="isUrl('tickets/tickets') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
            <div :class="isUrl('tickets/tickets') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('message.menu.tickets') }}</div>
          </Link>
        </template>
      </menu-accordion>
    </div>
    <div v-if="hasRole(['admin', 'exec', 'hr'])" class="mb-4">
      <menu-accordion :active="activeMenu === 'staffs'" @toggle="toggleMenu('staffs')">
        <template #title>
          <div :class="isUrl('staffs') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('message.menu.staffs') }}</div>
        </template>
        <template #content>
          <Link class="group flex items-center py-3 truncate" href="/staffs/nafa-staffs">
            <icon name="staffs" class="mr-2" :class="isUrl('staffs/nafa-staffs') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
            <div :class="isUrl('staffs/nafa-staffs') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('message.menu.nafa_staffs') }}</div>
          </Link>
          <Link class="group flex items-center py-3 truncate" href="/staffs/departments">
            <icon name="departments" class="mr-2" :class="isUrl('staffs/departments') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
            <div :class="isUrl('staffs/departments') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('message.menu.departments') }}</div>
          </Link>
        </template>
      </menu-accordion>
    </div>
    <div class="mb-4">
      <menu-accordion :active="activeMenu === 'loans'" @toggle="toggleMenu('loans')">
        <template #title>
          <div :class="isUrl('loans') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('message.menu.loans') }}</div>
        </template>
        <template #content>
          <Link class="group flex items-center py-3 truncate" href="/loans/loans">
            <icon name="loans" class="mr-2" :class="isUrl('loans/loans') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
            <div :class="isUrl('loans/loans') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('message.menu.loans') }}</div>
          </Link>
          <Link v-if="hasRole(['admin', 'exec', 'hr'])" class="group flex items-center py-3 truncate" href="/loans/loan-types">
            <icon name="loan-types" class="mr-2" :class="isUrl('loans/loan-types') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
            <div :class="isUrl('loans/loan-types') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('message.menu.loan_types') }}</div>
          </Link>
        </template>
      </menu-accordion>
    </div>
    <div class="mb-4">
      <menu-accordion :active="activeMenu === 'agencies'" @toggle="toggleMenu('agencies')">
        <template #title>
          <div :class="isUrl('agencies') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('message.menu.agents') }}</div>
        </template>
        <template #content>
          <Link v-if="hasRole(['admin', 'it', 'business development'])" class="group flex items-center py-3 truncate" href="/agencies/branches">
            <icon name="agencies" class="mr-2" :class="isUrl('agencies/branches') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
            <div :class="isUrl('agencies/branches') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('message.menu.sub_agents') }}</div>
          </Link>
          <Link class="group flex items-center py-3 truncate" href="/agencies/payouts">
            <icon name="branches" class="mr-2" :class="isUrl('agencies/payouts') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
            <div :class="isUrl('agencies/payouts') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('message.menu.payout_locations') }}</div>
          </Link>
        </template>
      </menu-accordion>
    </div>
    <div class="mb-4">
      <menu-accordion :active="activeMenu === 'leave'" @toggle="toggleMenu('leave')">
        <template #title>
          <div :class="isUrl('leave') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('message.menu.leave') }}</div>
        </template>
        <template #content>
          <Link class="group flex items-center py-3 truncate" href="/leave/leaves">
            <icon name="leaves" class="mr-2" :class="isUrl('leave/leaves') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
            <div :class="isUrl('leave/leaves') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('message.menu.leave') }}</div>
          </Link>
          <Link v-if="hasRole(['admin', 'it', 'hr'])" class="group flex items-center py-3 truncate" href="/leave/leave-types">
            <icon name="leave-types" class="mr-2" :class="isUrl('leave/leave-types') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
            <div :class="isUrl('leave/leave-types') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('message.menu.leave_type') }}</div>
          </Link>
        </template>
      </menu-accordion>
    </div>
    <div class="mb-4">
      <menu-accordion :active="activeMenu === 'expense'" @toggle="toggleMenu('expense')">
        <template #title>
          <div :class="isUrl('expense') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('message.menu.expenses') }}</div>
        </template>
        <template #content>
          <Link class="group flex items-center py-3 truncate" href="/expense/expenses">
            <icon name="expenses" class="mr-2" :class="isUrl('expense/expense') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
            <div :class="isUrl('expense/expenses') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('message.menu.expense_requests') }}</div>
          </Link>
          <Link v-if="hasRole(['admin', 'finance', 'exec'])" class="group flex items-center py-3 truncate" href="/expense/expense-tickets">
            <icon name="expense-tickets" class="mr-2" :class="isUrl('expense/expense-tickets') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
            <div :class="isUrl('expense/expense-tickets') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('message.menu.expense_tickets') }}</div>
          </Link>
        </template>
      </menu-accordion>
    </div>
    <div class="mb-4" v-if="hasRole(['admin', 'exec', 'finance', 'hr', 'it'])">
      <menu-accordion :active="activeMenu === 'reports'" @toggle="toggleMenu('reports')">
        <template #title>
          <div :class="isUrl('reports') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
            {{ $t('message.menu.reports') }}
          </div>
        </template>
        <template #content>
          <Link v-if="hasRole(['admin', 'exec', 'hr'])" class="group flex items-center py-3 truncate" href="/reports/staffs">
            <icon name="reports" class="mr-2" :class="isUrl('expense/expense') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
            <div :class="isUrl('reports/staffs') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
              {{ $t('message.menu.staffs_report') }}
            </div>
          </Link>
          <Link v-if="hasRole(['admin', 'exec', 'it'])" class="group flex items-center py-3 truncate" href="/reports/tickets">
            <icon name="reports" class="mr-2" :class="isUrl('expense/expense-tickets') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
            <div :class="isUrl('reports/tickets') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
              {{ $t('message.menu.tickets_report') }}
            </div>
          </Link>
          <Link v-if="hasRole(['admin', 'exec', 'finance'])" class="group flex items-center py-3 truncate" href="/reports/expense-tickets">
            <icon name="reports" class="mr-2" :class="isUrl('expense/expense-tickets') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
            <div :class="isUrl('reports/expense-tickets') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
              {{ $t('message.menu.expense_tickets_report') }}
            </div>
          </Link>
        </template>
      </menu-accordion>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import MenuAccordion from './MenuAccordion.vue'
import RoleChecker from './Helpers/RoleChecker'
import PermissionChecker from './Helpers/PermissionChecker'
import { ref } from 'vue'

export default {
  components: {
    Icon,
    Link,
    MenuAccordion,
    RoleChecker,
    PermissionChecker,
  },

  setup() {
    const activeMenu = ref(null)

    const toggleMenu = (menuName) => {
      activeMenu.value = activeMenu.value === menuName ? null : menuName
    }

    return {
      activeMenu,
      toggleMenu,
    }
  },

  methods: {
    hasRole(role) {
      var userRole = new RoleChecker(this.$page.props)
      return userRole.hasRole(role)
    },

    hasPermission(permission) {
      var userPermission = new PermissionChecker(this.$page.props)
      return userPermission.hasPermission(permission)
    },

    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
  },
}
</script>
